export const FREE_MINT_CONTRACT_ADDRESS = '0x637eeBB9c2AB4c947eb9189c7a5DfC43F409C04e'

export const MAINNET_API_KEY = '5CPKXUc2powZTNad0mAV2aWeQaUgqV9i'
export const MAINNET_NETWORK ='homestead'
